<div class="row">
    <div class="col-md-8">
        <h5 class="font-weight-bold">&nbsp;&nbsp;{{formTitle}}</h5>
    </div>
    <div class="col-md-4 text-right">
        <button class="btn btn btn-sm btn-primary btn-square" id="addEmployeeBackBtn" type="button" (click)="onBack()">Back</button>
    </div>
</div>
<app-example-wrapper-seamless>
    <div class="card card-box mb-5">
        <div class="card-body">
            <h5 class="card-title font-weight-bold font-size-lg mb-4">Personal Info1</h5>
            <form [formGroup]="employee_form">
                <div class="row">
                    <div class="col-md-3 col-sm-6">
                        <div class="form-group">
                            <label for="empid">Employee ID*</label>
                            <input id="empid" class="form-control" formControlName="empid" placeholder="Employee id" type="text" [ngClass]="{'is-invalid': submitted && f.empid.errors}">
                            <div *ngFor="let validation of validation_messages.empid">
                                <div class="error-message" *ngIf="f.empid.hasError(validation.type) && ((f.empid.dirty  || f.empid.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="form-group"><label for="fname">First Name *
                            </label><input id="fname" class="form-control" formControlName="fname" placeholder="First Name" type="text" [ngClass]="{'is-invalid': submitted && f.fname.errors}">
                            <div *ngFor="let validation of validation_messages.fname">
                                <div class="error-message" *ngIf="f.fname.hasError(validation.type) && ((f.fname.dirty || f.fname.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="form-group"><label for="lname">Last Name *
                            </label><input id="lname" class="form-control" formControlName="lname" placeholder="Last Name" type="text" [ngClass]="{'is-invalid': submitted && f.lname.errors}">
                            <div *ngFor="let validation of validation_messages.lname">
                                <div class="error-message" *ngIf="f.lname.hasError(validation.type) && ((f.lname.dirty || f.lname.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="form-group">
                            <label for="dobCalenderIcon">Date of birth </label>
                            <div class="input-group input-group-lg" [ngClass]="{'is-invalid': submitted && f.dob.errors}">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <fa-icon id="dobCalenderIcon" [icon]="['far', 'calendar-alt']" class="mx-auto">
                                        </fa-icon>
                                    </span>
                                </div>
                                <input [minDate]="minDate" [maxDate]="maxDate" id="dob" [bsConfig]="{ dateInputFormat: 'MM/DD',containerClass: 'theme-primary', isAnimated: true ,customTodayClass:'custom-today-class' }" bsDatepicker class="form-control" placeholder="Select date" formControlName="dob"
                                    type="text" [ngClass]="{'is-invalid': submitted && f.dob.errors}">
                            </div>
                            <!-- <div *ngFor="let validation of validation_messages.dob">
                                <div class="error-message"
                                    *ngIf="f.dob.hasError(validation.type) && ((f.dob.dirty || f.dob.touched))">
                                    {{validation.message }}
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 col-sm-6">
                        <div class=" form-group"><label for="email">Email *
                            </label><input id="email" class="form-control" formControlName="email" placeholder="Email" type="text" [ngClass]="{'is-invalid': submitted && f.email.errors}">
                            <div *ngFor="let validation of validation_messages.email">
                                <div class="error-message" *ngIf="f.email.hasError(validation.type) && ((f.email.dirty || f.email.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="form-group">
                            <label for="mobileNumber">Phone No *</label>
                            <input id="mobileNumber" class="form-control" formControlName="mobileNumber" placeholder="Mobile number" type="text" [ngClass]="{'is-invalid': submitted && f.mobileNumber.errors}">
                            <div *ngFor="let validation of validation_messages.mobileNumber">
                                <div class="error-message" *ngIf="f.mobileNumber.hasError(validation.type) &&  ((f.mobileNumber.dirty ||  f.mobileNumber.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="form-group"><label for="languages">Languages *</label>
                            <ng-select id="languages" [multiple]="true" placeholder="Select languages" formControlName="languages" [(ngModel)]="selectedLanguageids" required [ngClass]="{'is-invalid': submitted && f.languages.errors}">
                                <ng-option *ngFor="let language of allLanguages" [value]="language.languageId">
                                    {{language.description}} </ng-option>
                            </ng-select>
                            <div *ngFor="let validation of validation_messages.languages">
                                <div class="error-message" *ngIf="f.languages.hasError(validation.type) &&  ((f.languages.dirty ||  f.languages.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class=" form-group">
                            <label for="password">Password *</label>
                            <div class="input-group">
                                <input id="password" class="form-control" [type]="!hide ? 'password' : 'text'" readonly formControlName="password" placeholder="Enter your password" required [ngClass]="{'is-invalid': submitted && f.password.errors}">
                                <div class="input-group-append">
                                    <span class="input-group-text" style="padding: 0rem 1rem !important;">
                                        <mat-icon class="placeholder" *ngIf="hide" tooltip="Hide password"
                                            (click)="myFunction()">
                                            {{'visibility_off'}}
                                        </mat-icon>
                                        <mat-icon class="placeholder" *ngIf="!hide" tooltip="Show password"
                                            (click)="myFunction()">
                                            {{ 'visibility'}}
                                        </mat-icon>
                                    </span>
                                </div>
                            </div>
                            <div *ngFor="let validation of validation_messages.password">
                                <div class="error-message" *ngIf="f.password.hasError(validation.type) &&  ((f.password.dirty || f.password.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class=" form-group">
                            <label for="address1">Address Line1</label>
                            <input id="address1" class="form-control" formControlName="address1" placeholder="Address Line1" type="text" maxlength="20">
                        </div>
                    </div>

                    <div class="col-md-3 col-sm-6">
                        <div class="form-group">
                            <label for="address2">Address Line2 </label>
                            <input id="address2" class="form-control" formControlName="address2" placeholder="Address Line1" type="text" maxlength="20">
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="form-group">
                            <label for="cityname">City </label>
                            <input id="cityname" class="form-control" formControlName="cityname" placeholder="City" type="text" maxlength="20">
                        </div>
                    </div>

                    <div class="col-md-3 col-sm-6">
                        <div class="form-group"><label for="country">Country</label>
                            <ng-select id="country" placeholder="Select Country" formControlName="country" [(ngModel)]="selectedCountry" (change)="onCountryChange()">
                                <ng-option *ngFor="let country of allCountries" [value]="country">
                                    {{country}}
                                </ng-option>
                            </ng-select>

                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="form-group">
                            <label for="state">State</label>
                            <ng-select id="state" placeholder="Select State" formControlName="state" [(ngModel)]="selectedState">
                                <ng-option *ngFor="let s of allStates" [value]="s.state">
                                    {{s.state}}
                                </ng-option>
                            </ng-select>
                        </div>

                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="position-relative form-group"><label for="zipcode">Zip/Postal Code
                            </label><input id="zipcode" class="form-control" formControlName="zipcode" placeholder="Address Line1" type="text" >
                            <div *ngFor="let validation of validation_messages.zipcode">
                                <div class="error-message" *ngIf="f.zipcode.hasError(validation.type) && ((f.zipcode.dirty || f.zipcode.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-md-12">
                        <h5 class="card-title font-weight-bold font-size-lg py-3">Job Details</h5>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="position-relative form-group"><label for="jobtype">Job Code *
                            </label>
                            <ng-select id="jobtype" formControlName="jobtype" [(ngModel)]="selectedJobType" [ngClass]="{'is-invalid': submitted && f.jobtype.errors}" placeholder="Select job code">
                                <ng-option *ngFor="let jobtype of jobTypes" [value]="jobtype">{{jobtype}} </ng-option>
                            </ng-select>
                            <div *ngFor="let validation of validation_messages.jobtype">
                                <div class="error-message" *ngIf="f.jobtype.hasError(validation.type) && ((f.jobtype.dirty || f.jobtype.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3 col-sm-6">
                        <div class="position-relative form-group">
                            <label for="role">Role *</label>
                            <ng-select id="role" placeholder="Select Role" formControlName="role" [(ngModel)]="selectedRole" (change)="onRoleChange()" (click)="onRoleChange()" [ngClass]="{'is-invalid': submitted && f.role.errors}">
                                <ng-option *ngFor="let role of roles" [value]="role">{{role.name}}</ng-option>
                            </ng-select>
                            <div *ngFor="let validation of validation_messages.role">
                                <div class="error-message" *ngIf="f.role.hasError(validation.type) && ((f.role.dirty || f.role.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="position-relative form-group">
                            <label for="source">Source *</label>
                            <ng-select id="source" placeholder="Select Source" formControlName="source" [(ngModel)]="selectedSource" >
                                <ng-option *ngFor="let source of sources" [value]="source.value">{{source.label}}</ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6" *ngIf="isEditMode">
                        <div class="position-relative form-group">
                            <label for="status">Status *</label>
                            <ng-select id="status" formControlName="status" [(ngModel)]="selectedStatus" placeholder="Select status" [ngClass]="{'is-invalid': submitted && f.status.errors}">
                                <ng-option *ngFor="let s of status" [value]="s">{{s}} </ng-option>
                            </ng-select>
                            <div *ngFor="let validation of validation_messages.status">
                                <div class="error-message" *ngIf="f.status.hasError(validation.type) && ((f.status.dirty || f.status.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3 col-sm-6" *ngIf="employeeData!=null && isEditMode &&  !employeeData.status">
                        <label for="terminateDateCalenderIcon">Termination date *</label>
                        <div class="input-group input-group-lg">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <fa-icon id="terminateDateCalenderIcon" [icon]="['far', 'calendar-alt']"
                                        class="mx-auto"></fa-icon>
                                </span>
                            </div>
                            <input id="terminateddate" [bsConfig]="{ containerClass: 'theme-primary', isAnimated: true,customTodayClass:'custom-today-class'  }" bsDatepicker class="form-control" placeholder="Select date" formControlName="terminateddate" type="text" [ngClass]="{'is-invalid': submitted && f.terminateddate.errors}">
                        </div>
                        <div *ngFor="let validation of validation_messages.terminateddate">
                            <div class="error-message" *ngIf="f.terminateddate.hasError(validation.type) && ((f.terminateddate.dirty || f.terminateddate.touched))">
                                {{validation.message }}
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3 col-sm-6">
                        <label for="hireDateCalenderIcon">Hire date *</label>
                        <div class="input-group input-group-lg">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <fa-icon id="hireDateCalenderIcon" [icon]="['far', 'calendar-alt']" class="mx-auto">
                                    </fa-icon>
                                </span>
                            </div>
                            <input id="hiredate" [minDate]="minDate" [maxDate]="maxDate" [bsConfig]="{ containerClass: 'theme-primary', isAnimated: true, customTodayClass:'custom-today-class'}" bsDatepicker class="form-control" placeholder="Select date" formControlName="hiredate"
                                type="text" [ngClass]="{'is-invalid': submitted && f.hiredate.errors}">
                        </div>
                        <div *ngFor="let validation of validation_messages.hiredate">
                            <div class="error-message" *ngIf="f.hiredate.hasError(validation.type) && ((f.hiredate.dirty || f.hiredate.touched))">
                                {{validation.message }}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6" *ngIf="selectedRole!=null && selectedRole.access_level===3">
                        <div class="form-group">
                            <label for="dailycap">Daily Greet Cap*</label>
                            <input id="dailycap" class="form-control" formControlName="dailycap" placeholder="Daily Cap" type='number' [ngClass]="{'is-invalid': submitted && f.dailycap.errors}">
                            <div *ngFor="let validation of validation_messages.dailycap">
                                <div class="error-message" *ngIf="f.dailycap.hasError(validation.type) && ((f.dailycap.dirty || f.dailycap.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3 col-sm-6" *ngIf="selectedRole!=null && selectedRole.access_level===3">
                        <div class="form-group">
                            <label for="weeklycap">Weekly Greet Cap* </label>
                            <input id="weeklycap" class="form-control" formControlName="weeklycap" placeholder="Weekly Cap" type='number' [ngClass]="{'is-invalid': submitted && f.weeklycap.errors}">
                            <div *ngFor="let validation of validation_messages.weeklycap">
                                <div class="error-message" *ngIf="f.weeklycap.hasError(validation.type) && ((f.weeklycap.dirty || f.weeklycap.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3 col-sm-6" *ngIf="selectedRole!=null && selectedRole.access_level===3">
                        <div class="form-group">
                            <label for="hourlyrate">Hourly rate *</label>
                            <input id="hourlyrate" class="form-control" formControlName="hourlyrate" placeholder="Hourly rate" type='number' [ngClass]="{'is-invalid': submitted && f.hourlyrate.errors}">
                            <div *ngFor="let validation of validation_messages.hourlyrate">
                                <div class="error-message" *ngIf="f.hourlyrate.hasError(validation.type) && ((f.hourlyrate.dirty || f.hourlyrate.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="col-md-3 col-sm-6">
                        <div class="position-relative form-group"><label for="traineeType">Trainee *
                            </label>
                            <ng-select id="traineeType" formControlName="traineeType" [(ngModel)]="selectedTraineeType"
                                [ngClass]="{'is-invalid': submitted && f.traineeType.errors}" placeholder=" Trainee? ">
                                <ng-option *ngFor="let traineeType of traineeTypes" [value]="traineeType">
                                    {{traineeType}} </ng-option>
                            </ng-select>
                            <div *ngFor="let validation of validation_messages.traineeType">
                                <div class="error-message"
                                    *ngIf="f.traineeType.hasError(validation.type) && 
                                                                        ((f.traineeType.dirty || f.traineeType.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div> -->

                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="stations">Stations *</label>
                            <ng-select id="stations" [multiple]="true" required formControlName="stations" [(ngModel)]="selectedStations" [ngClass]="{'is-invalid': submitted && f.stations.errors}" placeholder="Select Station" (change)="onStationChange($event)">
                                <ng-option *ngFor="let station of allStations" [value]="station.id">
                                    {{station.stationid}} - {{station.airport_name}}
                                </ng-option>
                            </ng-select>
                            <div *ngFor="let validation of validation_messages.stations">
                                <div class="error-message" *ngIf="f.stations.hasError(validation.type) && ((f.stations.dirty || f.stations.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 py-3">
                        <button id="backBtn" class="btn btn m-2 btn-neutral-primary btn-square" type="button" (click)="onBack()">Back</button>
                        <button id="saveTeamMemberBtn" class="btn m-2 btn-primary btn-square" type="button" (click)="onAddEmployee(employee_form.value)" *ngIf="!isEditMode">Add Team Member</button>
                        <button id="updateTeamMemberBtn" class="btn m-2 btn-primary btn-square" type="button" (click)="onUpdateEmployee(employee_form.value)" *ngIf="isEditMode">Update Team
                            Member</button>
                        <button id="resetBtn" class="btn m-2 btn-dark btn-square" type="button" (click)="onRest()">Reset</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <notifier-container></notifier-container>
</app-example-wrapper-seamless>

<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>